export default __webpack_public_path__ + "static/media/responsiveroadmap2.a8bc8b7f.png";